

























































































































import { Component, Mixins, Ref, Vue, Watch } from 'vue-property-decorator'
import APP_CONST from '@/constants/AppConst'
import BouncingPreloader from '@/commoncomponents/bouncingpreloadercomponent/BouncingPreloaderComponent.vue'
import Spinner from '@/commoncomponents/spinner/Spinner.vue'
import Stepper, { CheckoutStep } from '@/components/familyPortal/checkout/stepper/Stepper.vue'
import ApplicationCard from '@/components/familyPortal/checkout/checkoutApplicationCard/ApplicationCard.vue'
import Forms from '@/components/familyPortal/forms/Forms.vue'
import ApplicationInformation from '@/components/familyPortal/manageApplications/applicationInformation/ApplicationInformation.vue'
import SelectScholar from '@/components/familyPortal/manageApplications/selectScholar/SelectScholar.vue'
import AlreadySubmittedSite from '@/components/familyPortal/popupComponents/alreadySubmittedSite/AlreadySubmittedSite.vue'
import MultiParticipantDiscountBadge from '@/components/familyPortal/sessionCard/MultiParticipantDiscountBadge.vue'
import { ScreenText } from '@/lang/ScreenText'
import AccountSettings from '@/mixins/accountSettings.mixin'
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin'
import { ApplicationSubmission, DuplicateApplicationErrorType } from '@/Model/application/types'
import { CartApplication, IndexAction } from '@/Model/checkout/cart/types'
import { Scholar } from '@/Model/enrollment/types'
import { AutoSaveState } from '@/Model/forms/types'
import { ScholarDropdown } from '@/Model/model'
import { CatalogSession, PaymentOnboardingStatus } from '@/Model/sessions/catalogTypes'
import AgeRestrictionAlert from '@/popupcomponents/ageRestrictionAlert/AgeRestrictionAlert.vue'
import LeaveAlert from '@/popupcomponents/leaveAlert/LeaveAlert.vue'
import { doScholarsMatch } from '@/services/checkout/cart/helpers'
import applicationStore from '@/store/modules/applications/applicationStore'
import cart from '@/store/modules/checkout/cart/module'
import commonEntry from '@/store/modules/commonEntry'
import formsStore from '@/store/modules/forms/formsStore'
import APP_UTILITIES from '@/utilities/commonFunctions'
import discountStore from '@/store/modules/discounts'

Component.registerHooks(['beforeRouteLeave', 'beforeRouteEnter'])

@Component({
  components: {
    Spinner,
    BouncingPreloader,
    Stepper,
    SelectScholar,
    ApplicationInformation,
    Forms,
    ApplicationCard,
    LeaveAlert,
    AgeRestrictionAlert,
    AlreadySubmittedSite,
    MultiParticipantDiscountBadge
  }
})
export default class CheckoutApply extends Mixins(DeviceWidthCheckerMixin, AccountSettings) {
  public readonly CheckoutStep = CheckoutStep
  public readonly screenText = new ScreenText()
  public readonly APP_ROUTES = APP_CONST.APP_ROUTES
  public shouldLeaveRoute: boolean = false
  public nextRoute: any = {}
  public prevRoute: any = {}
  public isRoutedFromSubmit: boolean = false
  public isRemovingApplication: boolean = false
  public cart = cart
  public isReloadingCart: boolean = false
  public isPaymentPlanFlagEnabled = false
  APP_CONST = APP_CONST

  private removingFirstApplication: boolean = false
  private removingLastApplication: boolean = false

  private onFormValidationRanCallbackFn = async (valid: boolean) => {
    if (valid) {
      if (!this.isLastApplicationCurrentlySelected) {
        this.setIsReloadingCart(true)
        await this.cart.fetchCartForUser(false)
      }
      this.handleNextOnFormView()
    }
  }

  showScholarSelection: boolean = true
  isAlreadySubmittedSiteVisible: boolean = false
  isAgeRestrictionAlertVisible: boolean = false
  isLeaveAlertVisible: boolean = false
  shouldBypassLeaveAlert: boolean = false
  nextBtnClickedOnFormView: boolean = false
  isAutomaticDiscountEnabled: boolean = false

  async created() {
    //FF: Automatic Discounts
    const automaticDiscountFlag = await APP_UTILITIES.getFeatureFlag(
      APP_CONST.FEATURE_KEYS.automaticDiscounts
    )
    this.isAutomaticDiscountEnabled = automaticDiscountFlag

    this.isPaymentPlanFlagEnabled = await APP_UTILITIES.getFeatureFlag(
      APP_CONST.FEATURE_KEYS.paymentPlans
    )

    this.onCreated()
  }

  @Ref('selectScholar') selectScholarRef?: SelectScholar

  @Watch('autoSaveState')
  async onAutoSaveState() {
    if (this.nextBtnClickedOnFormView && formsStore.autoSaveState === AutoSaveState.Completed) {
      if (this.shouldProceedToSubmit) {
        cart.APPLICATIONS_COMPLETE()
        this.setIsReloadingCart(false)
        this.$router.push(this.APP_ROUTES.CHECKOUT_SUBMIT.path)
      } else {
        await cart.loadCartApplicationData({
          indexAction: IndexAction.Increment
        })
        this.showScholarSelection = true
        this.nextBtnClickedOnFormView = false
        this.setIsReloadingCart(false)
      }
    }
  }

  @Watch('showScholarSelection', { immediate: true })
  onShowScholarSelectionChanged(showSelection: boolean) {
    if (showSelection) {
      applicationStore.RESET_SELECTED_CHILD()
    }
  }

  /* PROD-124 -- All of these changes were mounted
  in SiteListing as part of the Application process.
  Calling them here as well for minimal impact to existing code.*/
  mounted() {
    this.onMounted()
  }

  get designColor(): string {
    return commonEntry.accountDesignDetails.accentColor
  }

  get disableNextButton(): boolean {
    if (this.showScholarSelection) {
      const child = applicationStore.selectedChildData
      if (child.id === undefined) {
        return false
      }
      return child.id ? child.id === 0 : true
    }
    return !(
      formsStore &&
      formsStore.formsList &&
      formsStore.formsList.scholar &&
      formsStore.formsList.scholar.scholarName &&
      formsStore.formsList.scholar.scholarbirthdateField &&
      formsStore.formsList.scholar.scholarName.scholar_firstname &&
      formsStore.formsList.scholar.scholarName.scholar_lastname &&
      formsStore.formsList.scholar.scholarbirthdateField.scholar_birthdate
    )
  }

  get isFetchingCart(): boolean {
    return cart.isFetchingCart || cart.isUpdatingCart || cart.isDeleting
  }

  get isLoadingElasticFormData(): boolean {
    return formsStore.isLoadingElasticFormData
  }

  get isLoadingFormApplicationData(): boolean {
    return formsStore.isLoadingFormData
  }

  get isLoadingScholarAssociation(): boolean {
    return cart.isAssociatingScholar
  }

  get isFirstApplicationCurrentlySelected(): boolean {
    return cart.currentlySelectedApplicationIndex === 0
  }

  get isLastApplicationCurrentlySelected(): boolean {
    return (
      !!cart.cartApplications &&
      cart.currentlySelectedApplicationIndex ==
        cart.cartApplications.cartItemApplicationData.length - 1
    )
  }

  get currentlySelectedApplicationSession(): CatalogSession | undefined | null {
    return (
      cart.currentlySelectedCartApplication &&
      cart.currentlySelectedCartApplication.cartItem &&
      cart.currentlySelectedCartApplication.cartItem.session
    )
  }

  get currentlySelectedApplicationIndex(): number {
    return cart.currentlySelectedApplicationIndex
  }

  get shouldProceedToSubmit(): boolean {
    return (
      !!cart.cartApplications &&
      this.isLastApplicationCurrentlySelected &&
      !this.showScholarSelection
    )
  }

  get shouldProceedToReview(): boolean {
    return !!cart.cartApplications && this.isFirstApplicationCurrentlySelected
  }

  get isLoadingCartApplicationsData(): boolean {
    return cart.isLoadingCartApplicationsData
  }

  get currentlySelectedCartApplication(): CartApplication | null {
    return cart.currentlySelectedCartApplication ? cart.currentlySelectedCartApplication : null
  }

  get currentlySelectedCartApplicationSubmissionInProgress(): ApplicationSubmission | null {
    return cart.currentlySelectedCartApplication &&
      cart.currentlySelectedCartApplication.applicationInProgress
      ? cart.currentlySelectedCartApplication.applicationInProgress
      : null
  }

  get currentlySelectedScholar(): ScholarDropdown | undefined {
    return applicationStore.allSelectedChildData
  }

  get currentApplicationSubmissionForSelectedScholar(): ApplicationSubmission | null {
    let result: ApplicationSubmission | null = null
    if (
      this.currentlySelectedScholar &&
      cart.cartApplications &&
      this.currentlySelectedCartApplication
    ) {
      for (const cartApplication of cart.cartApplications.cartItemApplicationData) {
        const applicationInProgress = cartApplication.applicationInProgress
        if (applicationInProgress) {
          const rawApplicationIdMatches =
            this.currentlySelectedCartApplication.rawApplicationId ===
            applicationInProgress.formsList.elasticApplicationId // TODO: verify this is the right ID when autosave is enabled in PROD-1737
          const hasApplicableSessionId = applicationInProgress.formsList.siteIds.includes(
            this.currentlySelectedCartApplication.sessionId
          )
          if (
            rawApplicationIdMatches &&
            hasApplicableSessionId &&
            this.currentlySelectedScholar.firstName &&
            this.currentlySelectedScholar.lastName &&
            this.currentlySelectedScholar.DOB &&
            applicationInProgress.scholardob
          ) {
            const trimmedCurrentlySelectedScholarDob = this.currentlySelectedScholar.DOB.trim()
            let trimmedApplicationInProgressScholarDob = applicationInProgress.scholardob.trim()
            const trimmedApplicationInProgressScholarDobHasSpaces =
              !!trimmedApplicationInProgressScholarDob.match(/^\d{2} - \d{2} - \d{4}$/)
            if (trimmedApplicationInProgressScholarDobHasSpaces) {
              trimmedApplicationInProgressScholarDob =
                trimmedApplicationInProgressScholarDob.replace(/\s+/g, '')
            }
            const currentlySelectedBirthDateAsDate = new Date(trimmedCurrentlySelectedScholarDob)
            const applicationInProgressScholarDobAsDate = new Date(
              trimmedApplicationInProgressScholarDob
            )
            const dobMatches =
              currentlySelectedBirthDateAsDate.toISOString() ===
              applicationInProgressScholarDobAsDate.toISOString()
            const firstNameMatches =
              this.currentlySelectedScholar.firstName.toLocaleLowerCase() ===
              applicationInProgress.scholar.scholar_firstname.toLocaleLowerCase()
            const lastNameMatches =
              this.currentlySelectedScholar.lastName.toLocaleLowerCase() ===
              applicationInProgress.scholar.scholar_lastname.toLocaleLowerCase()
            if (dobMatches && firstNameMatches && lastNameMatches) {
              result = applicationInProgress
              break
            }
          }
        }
      }
    }
    return result
  }

  get currentApplicationSubmissionSessionIds(): Array<number> {
    let result: Array<number> = []
    if (this.currentlySelectedCartApplication) {
      if (this.currentApplicationSubmissionForSelectedScholar) {
        result = [...this.currentApplicationSubmissionForSelectedScholar.siteIds]
      }
      if (!result.includes(this.currentlySelectedCartApplication.sessionId)) {
        result.push(this.currentlySelectedCartApplication.sessionId)
      }
    }
    return result
  }

  get autoSaveState(): AutoSaveState {
    return formsStore.autoSaveState
  }

  get nextButtonDisabled(): boolean {
    return this.nextBtnClickedOnFormView && formsStore.autoSaveState === AutoSaveState.InProgress
  }

  get hasOnlinePayments(): boolean {
    return commonEntry.accountPaymentOnboardingStatus === PaymentOnboardingStatus.Complete
  }

  get isDiscountRequestInProgress(): boolean {
    return discountStore.discountRequestInProgress
  }

  get doesMultiParticipantDiscountExist(): boolean {
    return discountStore.doesMultiParticipantDiscountExist
  }

  setIsReloadingCart(value: boolean) {
    this.isReloadingCart = value
    Vue.prototype.$eventHub.$emit(APP_CONST.CART_IS_RELOADING_EVENT, value)
  }

  @Watch('currentApplicationSubmissionSessionIds')
  onCurrentApplicationSubmissionSessionIdsChanged() {
    localStorage.setItem(
      'all_selected_sites',
      JSON.stringify(this.currentApplicationSubmissionSessionIds)
    )
  }

  onStay() {
    this.isLeaveAlertVisible = false
    this.shouldLeaveRoute = false
  }

  async onYesLeave() {
    this.shouldLeaveRoute = true
    if (this.nextRoute.name == 'Dashboard' || this.nextRoute.name == 'Family Portal') {
      this.$router.push(APP_CONST.APP_ROUTES.DASHBOARD.path)
    } else {
      this.$router.push(this.nextRoute)
    }
  }

  @Watch('isFetchingCart')
  @Watch('cart.isInitializingCart')
  onCartSessionChange() {
    if (
      !cart.isInitializingCart &&
      !this.isFetchingCart &&
      !this.shouldProceedToSubmit &&
      !this.isReloadingCart
    ) {
      this.reloadApplications()
    }
  }

  async reloadApplications() {
    if (!this.isRemovingApplication) {
      cart.RESET_CART_APPLICATIONS()
    }

    applicationStore.getDropDownScholars(cart.userId)
    if (this.isRoutedFromSubmit) {
      await cart.loadCartApplicationData({ indexAction: IndexAction.SeekEnd })
      this.showScholarSelection = false
    } else {
      await cart.loadCartApplicationData()
    }
    this.setLocalStorageScholarSelected(false)
  }

  onCreated() {
    this.attachExternalListeners()
    if (!cart.isInitializingCart) {
      cart.fetchCartForUser()
    }
  }

  onMounted() {
    applicationStore.mutateDisableSite(true)
    APP_UTILITIES.setCookie('disableDocument', JSON.stringify(true), 1)
    APP_UTILITIES.removeSpecificCookie('outStandingItems')
    APP_UTILITIES.removeSpecificCookie('outStandingItemIndex')
    applicationStore.mutateIsOutstandingItems(false)
  }

  private setLocalStorageScholarSelected(value: boolean) {
    localStorage.setItem('scholar_selected', JSON.stringify(value))
  }

  private attachExternalListeners() {
    this.$root.$on(
      APP_CONST.CART_APPLICATION_VALIDATION_RAN_EVENT,
      this.onFormValidationRanCallbackFn
    )
    Vue.prototype.$eventHub.$on(
      APP_CONST.CART_APPLICATION_SCHOLAR_FN_LN_DOB_CHANGED_TRIGGER_EVENT,
      this.alertIfScholarAlreadyApplied
    )
    Vue.prototype.$eventHub.$on(
      APP_CONST.CART_APPLICATION_SCHOLAR_BIRTHDATE_CHANGED_TRIGGER_EVENT,
      this.onScholarBirthdateChanged
    )
  }

  private detachExternalListeners() {
    this.$root.$off(
      APP_CONST.CART_APPLICATION_VALIDATION_RAN_EVENT,
      this.onFormValidationRanCallbackFn
    )
    Vue.prototype.$eventHub.$off(
      APP_CONST.CART_APPLICATION_SCHOLAR_FN_LN_DOB_CHANGED_TRIGGER_EVENT,
      this.alertIfScholarAlreadyApplied
    )
    Vue.prototype.$eventHub.$off(
      APP_CONST.CART_APPLICATION_SCHOLAR_BIRTHDATE_CHANGED_TRIGGER_EVENT,
      this.onScholarBirthdateChanged
    )
  }

  async next() {
    if (formsStore.formsList.consents && formsStore.widgetList) {
      let matchCounter = 0
      const consentFormEntries = formsStore.widgetList
        .filter((val: any) => val.name.toLowerCase().includes('consent_agreement'))
        .reduce((acc: any, item: any, index: number) => {
          matchCounter = Math.floor(index / 2)
          acc[item.key] = {
            name: item.name,
            value: formsStore.formsList.consents[matchCounter].consent_Answer,
            required: item.options.required
          }
          return acc
        }, {}) // this one points to the answer but doesn't specify if is required

      const missingConsents: { [key: string]: any } = Object.entries(consentFormEntries)
        .filter(([key, value]) => (value as any).required === true && (value as any).value === '')
        .reduce(
          (obj, [subKey, subValue]) => {
            obj[subKey] = subValue
            return obj
          },
          {} as { [key: string]: any }
        )

      if (Object.keys(missingConsents).length > 0) {
        // if we don't have an answer for at least one required-consent field, we update the store to validate that the consent needs to be required
        formsStore.setConsentAgreementMap(consentFormEntries)
      } else {
        formsStore.setConsentAgreementMap(undefined)
      }
    }

    formsStore.resetAutoSaveState()
    if (!this.showScholarSelection) {
      if (!this.isAgeRestrictionAlertVisible) {
        this.$root.$emit(APP_CONST.CART_APPLICATION_VALIDATION_TRIGGER_EVENT)
      }
    } else {
      applicationStore.mutateChildrenDropdown({
        ...applicationStore.childrenDropdownObj,
        id: 0,
        value: 'Select child'
      })
      this.selectScholarRef && this.selectScholarRef.next()
    }
    APP_UTILITIES.segmentTrackEvent(
      APP_CONST.SEGMENT_EVENTS.SHOPPING_CART_APPLICATION.applyViewChildApplication
    )
    APP_UTILITIES.segmentTrackEvent(
      APP_CONST.SEGMENT_EVENTS.SHOPPING_CART_APPLICATION.viewPaymentScreen
    )
  }

  async handleNextOnScholarView(isScholarCurrentlyEnrolled: boolean) {
    if (!isScholarCurrentlyEnrolled && applicationStore.allSelectedChildData) {
      const selectedChild =
        applicationStore.allSelectedChildData.id != APP_CONST.ADD_NEW_CHILD.id
          ? applicationStore.allSelectedChildData
          : undefined
      await cart.associateScholarToCurrentlySelectedApplicationCartItem(selectedChild)

      if (!cart.didAssociateScholarFail) {
        await cart.loadCartApplicationData({
          resetFormScholarData: false
        })

        if (!cart.didFetchCartApplicationsFail) {
          this.setLocalStorageScholarSelected(false) // Seems counter-intuitive, but the Forms component relies on this being false to make the proper data API calls :\
          this.showScholarSelection = false
        }
      }
    }
  }

  showAlreadySubmittedSiteModal() {
    this.isAlreadySubmittedSiteVisible = true
  }

  handleNextOnFormView(): void {
    if (this.cart.invalidItemsRemoved) {
      this.shouldBypassLeaveAlert = true
      this.$router.push(this.APP_ROUTES.CHECKOUT_REVIEW.path)
      return
    }

    this.nextBtnClickedOnFormView = true
    this.$root.$emit(APP_CONST.CART_APPLICATION_SAVE_APPLICATION_FORMS_TRIGGER_EVENT) // Force-save the WIP Application
  }

  alertIfScholarAlreadyApplied() {
    const formScholar = this.getScholarInfoFromForm() as Scholar
    if (formScholar && formScholar.firstName && formScholar.lastName && formScholar.birthDate) {
      const scholarAlreadyHasSubmittedApplication =
        !!cart.currentlySelectedCartApplication &&
        formScholar &&
        applicationStore.childrenDropdown.dropdownList.some(
          (dropdownItem) =>
            doScholarsMatch(formScholar, {
              firstName: dropdownItem.firstName,
              lastName: dropdownItem.lastName,
              birthDate: dropdownItem.DOB
            } as Scholar) &&
            dropdownItem.siteIds &&
            dropdownItem.siteIds.includes(cart.currentlySelectedCartApplication!.sessionId)
        )
      const scholarAlreadyHasInProgressApplication =
        cart.cartApplications &&
        cart.cartApplications.cartItemApplicationData.some(
          (x, index) =>
            x.applicationInProgress &&
            x.applicationInProgress.scholardob &&
            doScholarsMatch(formScholar, {
              firstName: x.applicationInProgress.scholar.scholar_firstname,
              lastName: x.applicationInProgress.scholar.scholar_lastname,
              birthDate: x.applicationInProgress.scholardob
            } as Scholar) &&
            cart.currentlySelectedCartApplication &&
            x.sessionId === cart.currentlySelectedCartApplication.sessionId &&
            index !== cart.currentlySelectedApplicationIndex
        )

      const scholarAlreadyApplied =
        scholarAlreadyHasSubmittedApplication || scholarAlreadyHasInProgressApplication
      if (scholarAlreadyApplied) {
        if (scholarAlreadyHasSubmittedApplication) {
          applicationStore.SET_DUPLICATE_APPLICATION_ERROR_TYPE(
            DuplicateApplicationErrorType.Completed
          )
        } else if (scholarAlreadyHasInProgressApplication) {
          applicationStore.SET_DUPLICATE_APPLICATION_ERROR_TYPE(
            DuplicateApplicationErrorType.InProgress
          )
        }
        this.showAlreadySubmittedSiteModal()
      }
    }
  }

  getScholarInfoFromForm(): Partial<Scholar> | null {
    let foundKeys = 0
    const formScholar = { firstName: '', lastName: '', birthDate: '' } as Partial<Scholar>
    const formFieldMap: Record<string, keyof typeof formScholar> = {
      scholar_firstname: 'firstName',
      scholar_lastname: 'lastName',
      scholar_birthdate: 'birthDate'
    }

    for (const widget of formsStore.widgetList) {
      const fieldName = formFieldMap[widget.name]
      if (fieldName) {
        formScholar[fieldName] = widget.options.defaultValue
        foundKeys++
      }
      if (foundKeys === 3) {
        break
      }
    }

    if (!formScholar.birthDate) {
      return null
    }
    formScholar.birthDate = `${APP_UTILITIES.formatShortDateFullYear(formScholar.birthDate.replace(/\s/g, ''))} 00:00`
    return formScholar
  }

  async previous() {
    if (!this.showScholarSelection) {
      this.showScholarSelection = true
      APP_UTILITIES.segmentTrackEvent(
        APP_CONST.SEGMENT_EVENTS.SHOPPING_CART_APPLICATION.applyViewChildSelection
      )
    } else if (this.shouldProceedToReview) {
      APP_UTILITIES.segmentTrackEvent(
        APP_CONST.SEGMENT_EVENTS.SHOPPING_CART_APPLICATION.applicationViewCart
      )
      this.$router.push(this.APP_ROUTES.CHECKOUT_REVIEW.path)
    } else {
      await cart.loadCartApplicationData({
        indexAction: IndexAction.Decrement
      })
      this.showScholarSelection = false
    }
  }

  onDestroy() {
    this.detachExternalListeners()
  }

  destroyed() {
    this.onDestroy()
  }

  async beforeRouteEnter(to: any, from: any, next: any) {
    next(
      (vm: {
        isRoutedFromSubmit: boolean
        prevRoute: { path: string | any[] }
        APP_ROUTES: { CHECKOUT_SUBMIT: { path: string } }
      }) => {
        vm.prevRoute = from
        if (vm.prevRoute.path.includes(vm.APP_ROUTES.CHECKOUT_SUBMIT.path)) {
          vm.isRoutedFromSubmit = true
          next()
        }
      }
    )
  }

  async beforeRouteLeave(to: any, from: any, next: any) {
    this.nextRoute = to
    if (
      to.path.includes(this.APP_ROUTES.CHECKOUT_SUBMIT.path) ||
      to.path.includes(this.APP_ROUTES.LOGIN.path)
    ) {
      next(true)
      return true
    }
    if (!this.isLeaveAlertVisible && !this.shouldBypassLeaveAlert) {
      this.isAgeRestrictionAlertVisible = false
      this.isLeaveAlertVisible = true
      next(false)
    }
    if (this.shouldLeaveRoute || this.shouldBypassLeaveAlert) {
      this.isLeaveAlertVisible = false
      this.shouldBypassLeaveAlert = false
      await this.$nextTick()
      next(true)
    }
    return true
  }

  onScholarBirthdateChanged() {
    // because of the current setup this event will be triggered on the next page as well 😩
    // so we need to check if we are on the current page first to avoid triggering the event twice
    if (APP_CONST.APP_ROUTES.CHECKOUT_APPLY.path === this.$route.path) {
      if (String(applicationStore.childrenDropdown.id) === '-1') {
        APP_UTILITIES.segmentTrackEvent(
          APP_CONST.SEGMENT_EVENTS.SHOPPING_CART_APPLICATION.cartAddNewChild
        )
      } else {
        APP_UTILITIES.segmentTrackEvent(
          APP_CONST.SEGMENT_EVENTS.SHOPPING_CART_APPLICATION.cartSelectExistingChild
        )
      }
    }

    if (!this.isAlreadySubmittedSiteVisible) {
      this.shouldShowAgeRestrictionAlert()
    }
  }

  private shouldShowAgeRestrictionAlert() {
    if (
      applicationStore.allSelectedChildData &&
      cart.currentlySelectedCartApplication &&
      cart.currentlySelectedCartApplication.cartItem &&
      cart.currentlySelectedCartApplication.cartItem.session
    ) {
      const { ageAsOf, ageTo, ageFrom } = cart.currentlySelectedCartApplication.cartItem.session
      const noAgeRestriction = ageFrom == null && ageTo == null

      if (ageAsOf == null || noAgeRestriction) {
        this.isAgeRestrictionAlertVisible = false
        return
      }

      const dob = this.showScholarSelection
        ? applicationStore.allSelectedChildData.DOB
        : formsStore.currentScholarBirthDate.replace(/\s/g, '').replace(/-/g, '/')

      if (dob == null) {
        this.isAgeRestrictionAlertVisible = false
        return
      }

      const dobStringTooSmall = dob.length !== 10
      if (!this.showScholarSelection && dobStringTooSmall) {
        this.isAgeRestrictionAlertVisible = false
        return
      }

      const age = APP_UTILITIES.calculateAge(dob, ageAsOf)
      if (age || age === 0) {
        const youngerThanMinAge = !!ageFrom && age < ageFrom
        const olderThanMaxAge = !!ageTo && age > ageTo
        const isAgeInvalid = youngerThanMinAge || olderThanMaxAge
        this.isAgeRestrictionAlertVisible = isAgeInvalid
        return
      }
    }
    this.isAgeRestrictionAlertVisible = false
    return
  }

  onChangeParticipantSelectedFromModal() {
    this.isAlreadySubmittedSiteVisible = false
    this.isAgeRestrictionAlertVisible = false
  }

  async onRemoveApplicationSelectedFromModal() {
    this.isRemovingApplication = true

    this.removingFirstApplication = this.isFirstApplicationCurrentlySelected
    this.removingLastApplication = this.isLastApplicationCurrentlySelected

    const cartItem = cart.currentlySelectedCartApplication!.cartItem!
    await cart.removeSpecificCartItem(cartItem)

    this.isAlreadySubmittedSiteVisible = false
    this.isAgeRestrictionAlertVisible = false
  }

  async onDynamicTextModalHidden() {
    if (this.isRemovingApplication) {
      applicationStore.RESET_SELECTED_CHILD()
      applicationStore.mutateChildrenDropdown({
        ...applicationStore.childrenDropdownObj,
        id: 0,
        value: 'Select child'
      })

      if (this.removingLastApplication) {
        this.shouldBypassLeaveAlert = true
        if (cart.cartItems.length === 0) {
          this.$router.push(APP_CONST.APP_ROUTES.PROGRAMS)
        } else {
          cart.APPLICATIONS_COMPLETE()
          await this.$nextTick()
          await cart.fetchCartForUser()
          this.$router.push(this.APP_ROUTES.CHECKOUT_SUBMIT.path)
        }
      } else {
        if (!this.removingFirstApplication) {
          cart.INCREMENT_CURRENTLY_SELECTED_APPLICATION()
        }
        this.showScholarSelection = true
      }
      this.removingFirstApplication = false
      this.removingLastApplication = false
      this.isRemovingApplication = false
    } else {
      if (this.showScholarSelection) {
        applicationStore.RESET_SELECTED_CHILD()
        applicationStore.mutateChildrenDropdown({
          ...applicationStore.childrenDropdownObj,
          id: 0,
          value: 'Select child'
        })
      } else {
        const ageRestrictionModalWasHidden = applicationStore.duplicateApplicationErrorType === null
        if (ageRestrictionModalWasHidden) {
          Vue.prototype.$eventHub.$emit(
            APP_CONST.CART_APPLICATION_RESET_SCHOLAR_BIRTHDATE_TRIGGER_EVENT
          )
        } else {
          Vue.prototype.$eventHub.$emit(APP_CONST.CART_APPLICATION_RESET_SCHOLAR_TRIGGER_EVENT)
          applicationStore.RESET_SELECTED_CHILD()
        }
      }
    }
  }
}
